/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 26th 2022, 4:30:24 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { COLORSCHEME } from "theme/styles";
import { Image } from "ui-widgets";

interface EmptyStateActionWrapperProps {
  title: React.ReactNode;
  description: React.ReactNode;
  illustrationGraphic?: React.ReactNode;
  children?: React.ReactNode;
}

export const EmptyStateActionWrapper = ({
  title,
  illustrationGraphic = <Image className="image-style-A" src="/img/illustration-1.png" alt="Onestop Admin" />,
  description,
  children: actions,
}: EmptyStateActionWrapperProps) => (
  <div className="os-empty-state text-center">
    <div className="os-empty-state-component os-empty-state-component-A">
      <div className="os-card-style-A-in-image">{illustrationGraphic}</div>
      <h4 style={{ color: COLORSCHEME.primary }}>{title}</h4>
      <p>{description}</p>
      <div className="card-cta-style-A">{actions}</div>
    </div>
  </div>
);
